<template>
    <b-container>
        <b-row>
            <b-col><label for="demo-sb">Start Row No:</label></b-col>
            <!-- -->
            <b-col
                ><b-form-spinbutton
                    id="demo-sb"
                    v-model="dataSettings.rowno"
                    min="1"
                    max="100"
                ></b-form-spinbutton
            ></b-col>
        </b-row>
        <hr />
        <b-row>
            <b-col><label>Field Names:</label> </b-col>
            <!-- -->
            <b-col><label>Columns</label> </b-col>
        </b-row>
        <hr />
        <b-row v-for="(item, i) in dataFields" :key="'sss' + i">
            <!-- add required field askterisk if the field is required -->
            <b-col
                >{{ item.name | capitalize
                }}<span v-if="item.required" style="color: red">*</span></b-col
            >
            <b-col v-if="!item.name.includes('date_format')">
                <b-form-spinbutton
                    :id="`'demo-sb-${item.name}`"
                    v-model="dataSettings[item.name]"
                    :formatter-fn="convertToAlpha"
                    min="-1"
                    max="25"
                ></b-form-spinbutton>
            </b-col>
            <!-- Add drop down for any date format selection fields -->
            <b-col v-else>
                <b-form-select
                    v-model="dataSettings[item.name]"
                    :options="item.options"
                >
                </b-form-select>
            </b-col>
        </b-row>
        <b-button variant="primary" @click="$emit('input', dataSettings)"
            >Update</b-button
        >
    </b-container>
</template>
<script>
import { capitalCase } from 'change-case'
export default {
    name: 'UploadDataSettings',
    props: ['value', 'dataFields'],
    data() {
        return {
            dataSettings: {},
        }
    },
    filters: {
        capitalize(x) {
            return capitalCase(x)
        },
    },
    watch: {
        value: {
            handler: function (val) {
                this.setSettings(val)
            },
            deep: true,
        },
    },
    mounted() {
        console.log('uploadDataSettings--mounted value', this.value)
        this.setSettings(this.value)
    },
    methods: {
        setSettings(_settings) {
            this.dataSettings = { ..._settings }
            for (const { name: key } of this.dataFields) {
                const value = this.dataSettings[key]
                if (typeof value == 'undefined' || value == null) {
                    this.$set(this.dataSettings, key, -1)
                }
            }
        },

        convertToAlpha(val) {
            return val > -1 ? String.fromCharCode(val + 65) : ''
        },
    },
}
</script>